import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  SecurityContext,
} from '@angular/core';
import { Variant } from '../../../pages/product/product-page/product.types';
import { TranslocoDirective } from '@jsverse/transloco';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Property } from '../../../pages/product/product-list/product-list.mapper';

@Component({
  selector: 'app-product-description',
  imports: [TranslocoDirective],
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDescriptionComponent {
  private _activeVariant!: Variant;
  private readonly sanitizer = inject(DomSanitizer);
  description!: SafeHtml;
  properties: Property[] = [];

  @Input({ required: true })
  set activeVariant(value: Variant) {
    this._activeVariant = value;
    this.properties = value.properties.filter((v) => v.showProperty);

    const originalContent = value.description ?? '';
    this.description =
      this.sanitizer.sanitize(SecurityContext.HTML, originalContent) ?? '';
  }

  get activeVariant(): Variant {
    return this._activeVariant;
  }
}
